"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoComponent = LogoComponent;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
function LogoComponent(props) {
    var size = props.size, navigateTo = props.navigateTo;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var logoSize = 56;
    return ((0, jsx_runtime_1.jsx)("svg", { className: "".concat(navigateTo ? "cursor-pointer" : ""), fill: "none", height: size, viewBox: "0 0 32 32", width: logoSize, onClick: function () {
            if (navigateTo) {
                navigate(navigateTo);
            }
        }, children: (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M17.6482 10.1305L15.8785 7.02583L7.02979 22.5499H10.5278L17.6482 10.1305ZM19.8798 14.0457L18.11 17.1983L19.394 19.4511H16.8453L15.1056 22.5499H24.7272L19.8798 14.0457Z", fill: "currentColor", fillRule: "evenodd" }) }));
}
